/**
 * Notifications API
 */

import { get, patch, del } from '@/services/shared/client'
import type { Notification } from '@/types/notification'

const LIMIT = 20

export interface NotificationsPage {
  notifications: Notification[]
  unreadCount: number
  hasMore: boolean
  nextCursor: string | null
}

interface NotificationsResponse {
  success: boolean
  data: NotificationsPage
}

export async function getNotifications(
  cursor?: string
): Promise<NotificationsPage> {
  const url = cursor
    ? `/notifications?limit=${LIMIT}&cursor=${cursor}`
    : `/notifications?limit=${LIMIT}`

  const response = await get<NotificationsResponse>(url)

  // Defensive check: ensure notifications is always an array
  return {
    ...response.data,
    notifications: response.data.notifications ?? [],
  }
}

export async function markNotificationAsRead(id: string): Promise<void> {
  await patch(`/notifications/${id}`, { isRead: true })
}

export async function markNotificationAsUnread(id: string): Promise<void> {
  await patch(`/notifications/${id}`, { isRead: false })
}

export async function markAllNotificationsAsRead(): Promise<void> {
  await patch('/notifications/mark-all-read')
}

export async function deleteNotification(id: string): Promise<void> {
  await del(`/notifications/${id}`)
}

export async function deleteAllNotifications(): Promise<void> {
  await del('/notifications')
}
